import styled from 'styled-components';

import Input from 'components/Input';

export const Icon = styled.span`
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;

  & > img {
    height: 28px;
    width: 28px;
  }
`;

export const StyledInputSecret = styled(Input)`
  & > div > input {
    padding-right: 50px;
  }
`;
